export function multimediaMacro() {
	// noop intentionally blank. Loaded and init via WRM
}

export function multimediaMacroWRM() {
	return ['wr!confluence.macros.multimedia:macro-browser-smart-fields'];
}
